import type {
  AgentDto,
  TranscriberResponseDto,
  VoiceDto,
} from '@shared/services/apiService/apiService';

import { isTranscriberRemoved } from '@shared/utils/removedAgentSettings';

export function resolveAgentVoice(agent: AgentDto, voices?: VoiceDto[] | null): VoiceDto | null {
  if (Array.isArray(voices)) {
    return voices.find((v) => v.id === agent.voiceId) ?? null;
  }
  return agent.voice ?? null;
}

export function resolveVoiceSortValue(agent: AgentDto, voices?: VoiceDto[] | null): string {
  return resolveAgentVoice(agent, voices)?.name || '';
}

export function resolveAgentTranscriber(
  agent: AgentDto,
  transcribers?: TranscriberResponseDto[] | null,
): TranscriberResponseDto | null {
  if (isTranscriberRemoved(agent, transcribers)) return null;

  const transcriberId = agent.transcriberId || agent.transcriber?.id;
  if (transcriberId && transcribers) {
    const fromCompany = transcribers.find((t) => t.id === transcriberId);
    if (fromCompany) return fromCompany;
  }
  if (agent.transcriber?.provider && agent.transcriber?.language) {
    return agent.transcriber;
  }
  return null;
}
